<script lang="ts">
  import {fly} from 'svelte/transition';
  import {cubicOut} from 'svelte/easing';
  import {stepMetaData$} from './streams';

  $: inFlyTransitionParams = generateComponentFlyParams($stepMetaData$);

  function generateComponentFlyParams(stepMetaData) {
    const {beforeSteps, steps} = stepMetaData;
    const isForward = steps.length > beforeSteps.length;
    const commonFlyParams = {
      duration: 500,
      delay: 0,
      opacity: 0,
      y: 0,
      easing: cubicOut,
    };
    if (isForward) {
      return {...commonFlyParams, x: 400};
    }
    return {...commonFlyParams, x: -400};
  }
</script>

<div class="transtion-wrap" in:fly={inFlyTransitionParams}>
  <slot />
</div>
